import {FETCH_OTP} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_OTP:
            return action.payload;
        default:
            return state;
    }
};